import script from "./DomainPermissionsList.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainPermissionsList.vue?vue&type=script&setup=true&lang=js"

import "./DomainPermissionsList.vue?vue&type=style&index=0&id=1ee06a9e&lang=css"

const __exports__ = script;

export default __exports__